import Icon from 'components/atoms/icon/Icon';
import NavItem from 'components/atoms/nav-item/NavItem';
import { useAuthContext } from 'lib/context/AuthContextContext/AuthContext';
import { IconType } from 'lib/helpers/constants/iconTypes';
import { ISideNavLinks, sideNavLinks } from 'lib/helpers/constants/sideNavLinks';
import { useLogout } from 'lib/hooks/mutations/Logout/useLogout';
import { useActiveLink } from 'lib/hooks/shared/useActiveLink';
import React, { useEffect, useState } from 'react'
import SideNavItem from '../sidenav/SidenavItem';
import Button from 'components/atoms/button/Button';
import { useThemeContext } from 'lib/context/ThemeContext/ThemeContext';
import { IVerifyToken } from 'lib/types/user.types';
import { useMultiStepFormContext } from 'lib/context/MultiStepFormContext/MultiStepFormContext';
import { useTranslation } from 'react-i18next';

const Navbar = () => {

    const { user } = useAuthContext();

    const { themeColors } = useThemeContext();

    const { setCurrentStep } = useMultiStepFormContext();

    const token: string | unknown = localStorage.getItem("token");

    const [OpenSideMenu, setOpenSideMenu] = useState(false)

    const { mutate: logout } = useLogout();

    const location = window.location.pathname;

    useEffect(() => {
        setOpenSideMenu(false)
    
     
    }, [location])
    

    const { handleActive } = useActiveLink(location);

    const [showDropDown, setShowDropDown] = useState<string | null>(null);

    const { t } = useTranslation();

    const handleDropdown = (event: React.MouseEvent, id: string) => {
        event.preventDefault();
        setShowDropDown(showDropDown === id ? null : id);
    };

    const renderDropDownMenu = (item: ISideNavLinks) => {
        if (item.children && showDropDown === item.id) {
            return (
                <ul
                    className={`flex flex-col gap-1 3xl:gap-[5px] ml-[11px] 2xl:ml-[15px]
                        transition-all duration-200 ease-in-out pb-2 pt-2 nth-of-type(2):p-[3px]`}
                >
                    {item.children.map((item: ISideNavLinks) => {
                        const isActiveChildren = location === item.path;
                        return (
                            <NavItem
                                item={item}
                                isActiveChildren={isActiveChildren}
                                key={`children-key-${item.id}`}
                                isToggled={false}
                                icon={item.icon as IconType}
                            />
                        );
                    })}
                </ul>
            );
        }
        return null;
    };

    return (
        <div className='relative md:hidden'>


            <div className='w-full flex items-center justify-between bg-white shadow-md p-4 fixed top-0 left-0 z-[9]'>
                <img
                    src={`https://mainhub.insuhub.ch/api/company-logo/${user.company.logo}`}
                    alt=""
                    className={` transition-all duration-200 ease-in-out object-contain  w-[50px] h-[40px] flex-none`}
                />
                <div className="cursor-pointer" onClick={() => { setOpenSideMenu(!OpenSideMenu) }}>
                    <Icon
                        iconType={IconType.MENU}
                    />
                </div>
                <div
                    className={`absolute top-[72px] w-full h-screen right-0 bg-white shadow-md p-4 transform transition-transform duration-300 ${OpenSideMenu ? 'translate-x-0' : 'translate-x-full'
                        }`}
                >
                    <div>
                        {sideNavLinks.map((item) => {
                            const isActive = location.includes(item.path);
                            return (
                                <SideNavItem
                                    key={`side-nav-key-${item.id}`}
                                    item={item}
                                    isToggled={false}
                                    isActive={isActive}
                                    showDropDown={showDropDown}
                                    handleDropdown={handleDropdown}
                                    themeColors={themeColors}
                                    handleActive={handleActive}
                                    renderDropDownMenu={renderDropDownMenu}
                                />
                            );
                        })}
                    </div>
                    <div className="mt-auto">
                        <Button
                            style={{
                                backgroundColor: themeColors.primary,
                            }}
                            className={`flex items-center gap-3 transition-all duration-200 ease-in-out text-white font-inter-bold bg-[--theme] rounded-xl p-3 mt-[20px] w-[129px] m-auto text-sm 3xl:text-base`}
                        >
                            <Icon iconType={IconType.SUPPORT_ICON} color="white" />
                            {t("Support")}
                        </Button>
                        <Button
                            className={`flex items-center gap-3 transition-all duration-200 ease-in-out font-inter-bold text-[#7D8592] mt-[30px] text-sm 3xl:text-base px-4`}
                            onClick={() => {
                                logout(token as IVerifyToken);
                                setCurrentStep(1);
                            }}
                        >
                            <Icon iconType={IconType.LOGOUT_ICON} />
                            {t("Logout")}
                        </Button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Navbar